type PartnerStatus = "STANDBY" | "ACTIVE" | "SHUTDOWN";

interface Partner {
  id?: string;
  code: string;
  name: string;
  useStartDate: string;
  useEndDate: string;
  contractUrl?: string;
  status?: PartnerStatus;
  statusDate?: string;
  createdDate?: string;
  lastModifiedDate?: string;
  lastModifiedBy?: string;
  features?: PaPartner[];
}

export interface PaPartner {
  active: boolean;
  name: NameType;
}

type NameType =
  | "CTRLROOM_NAVIGATION_MAINTENANCE_FEE"
  | "CTRLROOM_NAVIGATION_RESERVATION"
  | "CTRLROOM_NAVIGATION_CS"
  | "CTRLROOM_NAVIGATION_WORKORDER"
  | "FEATURE_TAAP_VOC"
  | "FEATURE_RESERVATION_POST_PAYMENT"
  | "CTRLROOM_PRODUCT_S2"
  | "CTRLROOM_PRODUCT_PUBLIC"
  | "FEATURE_CCTV"
  | "CTRLROOM_CS_AI"
  | "FEATURE_RESERVATION_ACCESS"
  | "CTRLROOM_RESERVATION_ESL_MASKING"
  | "FEATURE_ACCESS_GROUP_VISITOR_APPROVAL" //방문자 초대 승인
  | "CTRLROOM_RESERVATION_CALENDAR_DISPLAY"
  | "CTRLROOM_VISITOR_ACCESS_GROUP_SELECT" // 방문자 출입권한 여부 > 기본 권한 / 커스텀 권한
  | "FEATURE_VISITOR_SELF_REGIST" // 방문자 셀프 등록 기능
  | "FEATURE_VISITOR_TENANT_MANAGER_APPROVAL" // 방문자 초대 승인 기능 (이용자 마스터 승인)
  | "FEATURE_IOT_CONTROL" // 디바이스 제어 권한
  | "CTRLROOM_MEMBER_PARTNER_CUSTOM_INFO" // 이용자 부가정보 (STPM 회원 부가정보)
  | "CTRLROOM_ACCESS_GROUP_ACCESS_FLOORS"; // 출입그룹 엘리베이터 층수 제어 노출 여부

interface PaPartnerMember {
  id: string; // 아이디
  email: string; // 이메일
  connections?: string[]; // 로그인 수단 목록
  partners?: string[]; // 소속 파트너 목록
  lastLoginDate?: string; // 마지막 로그인 일시
  createdDate?: string; // 생성 일시
  blocked: boolean; // 상태
}

export const PartnerPrivilegeCode = {
  BASIC: "BASIC",
  BUILDING: "BUILDING",
  PRODUCT: "PRODUCT",
  WORKORDER: "WORKORDER",
  CS: "CS",
  CONTRACT: "CONTRACT",
  RESERVATION: "RESERVATION",
  VISITOR: "VISITOR",
  NOTICE: "NOTICE",
  CONTRACT_S2: "CONTRACT_S2",
} as const;

export type UnionPartnerPrivilegeCode = (typeof PartnerPrivilegeCode)[keyof typeof PartnerPrivilegeCode];

export const PrivilegeCodeMenus = {
  BASIC: [
    "main",
    "monitoring",
    "provider",
    "org",
    "price",
    "voc",
    "guide",
    "cctv",
    "access-group",
    "access-device",
    "reservationConfig",
    "iot-config",
    "access-record",
    "custom-link",
  ],
  BUILDING: ["building"],
  PRODUCT: ["product"],
  WORKORDER: ["workorder"],
  CS: ["question"],
  CONTRACT: ["contract", "billing", "user", "common-space-settlement"],
  RESERVATION: ["reservation"],
  VISITOR: ["visitor"],
  NOTICE: ["notice"],
  CONTRACT_S2: ["contract-s2", "billing-s2"],
};

// 파트너 권한 타입
export const PartnerPermission = {
  WRITE: "w", // 등록/수정
  READ: "r", // 읽기
  DELETE: "d", // 삭제
} as const;

export type UnionPartnerPermission = (typeof PartnerPermission)[keyof typeof PartnerPermission];

interface PartnerPrivilege {
  code: UnionPartnerPrivilegeCode;
  permissions: string[];
}

interface PaPartnerMemberAuthority {
  partnerId: string | number;
  memberId: string;
  email: string;
  blocked: boolean;
  readOnly: boolean;
  privileges: PartnerPrivilege[];
}

export type { PaPartnerMember, PaPartnerMemberAuthority, Partner, PartnerStatus };
